import {
  CestaState,
  Product,
} from '../../common/context/reducers/cestaReducer'
import { SelectedTaller, Taller } from '../../common/types/Taller'

/** Taller vàlid a la cesta (font de veritat del journey). */
export function hasCestaSelectedTaller(cestaState: CestaState): boolean {
  return Boolean(cestaState?.selectedTaller?.codigo_taller)
}

/**
 * Propaga cesta → buscador quan la cesta té taller i el catàleg encara no el té
 * o en té un de diferent (p. ex. re-triat al pas Tallers).
 */
export function shouldSyncCestaTallerToSearch(
  cestaTaller: SelectedTaller | null | undefined,
  searchTaller: Taller | null | undefined
): boolean {
  if (!cestaTaller?.codigo_taller) {
    return false
  }
  return searchTaller?.codigo_taller !== cestaTaller.codigo_taller
}

/**
 * @deprecated Usa shouldSyncCestaTallerToSearch. Es manté per compatibilitat de tests.
 */
export function shouldPropagateCestaTallerToSearch(
  cestaTaller: SelectedTaller | null | undefined,
  searchTaller: Taller | null | undefined
): boolean {
  return shouldSyncCestaTallerToSearch(cestaTaller, searchTaller)
}

export function isCarNeumaticoProduct(product: Product): boolean {
  if (product.tipo_producto !== 'neumatico') {
    return false
  }
  if (product.categoria === 'moto') {
    return false
  }
  return product.categoria === 'coche' || product.categoria == null
}

type CitaPreviaTallerState = {
  selectedTaller?: SelectedTaller
}

/** Taller confirmat al journey de cesta (sense fallback del catàleg neumàtics). */
export function resolveCestaJourneyTaller(
  cestaState: CestaState,
  citaPreviaState?: CitaPreviaTallerState
): SelectedTaller | null {
  if (cestaState.selectedTaller?.codigo_taller) {
    return cestaState.selectedTaller
  }
  if (citaPreviaState?.selectedTaller?.codigo_taller) {
    return citaPreviaState.selectedTaller
  }
  return null
}

/** Taller efectiu al checkout (cesta → cita prèvia → buscador cotxe). */
export function resolveCheckoutTaller(
  cestaState: CestaState,
  citaPreviaState?: CitaPreviaTallerState,
  searchTaller?: Taller | null
): SelectedTaller | null {
  if (cestaState.selectedTaller?.codigo_taller) {
    return cestaState.selectedTaller
  }
  if (citaPreviaState?.selectedTaller?.codigo_taller) {
    return citaPreviaState.selectedTaller
  }
  if (cestaHasCarNeumaticos(cestaState) && searchTaller?.codigo_taller) {
    return searchTaller
  }
  return null
}

/** La cesta conté pneumàtics de cotxe (el taller del buscador cotxe només aplica aquí). */
export function cestaHasCarNeumaticos(cestaState: CestaState): boolean {
  return cestaState.products.some(isCarNeumaticoProduct)
}

/**
 * Saltar «Escull taller» només si hi ha taller i la cesta té pneumàtics de cotxe
 * (p. ex. comprats des del catàleg amb taller preseleccionat).
 */
export function shouldSkipTallerSelection(cestaState: CestaState): boolean {
  if (cestaState.forceTallerSelection) {
    return false
  }
  return (
    hasCestaSelectedTaller(cestaState) && cestaHasCarNeumaticos(cestaState)
  )
}
